export default [
	{
		key: "id",
		title: "ID",
		scopedSlots: { customRender: "id" }
	},
	{
		key: "created_at",
		title: "Transaction Date & Time",
		scopedSlots: { customRender: "created_at" }
	},
	{
		key: "agent_name",
		title: "Agent Name",
		scopedSlots: { customRender: "agent_name" }
	},
	{
		key: "agent_type",
		title: "Agent Type (BSA dan Non BSA)",
		scopedSlots: { customRender: "agent_type" }
	},
	{
		key: "mid",
		title: "MID",
		scopedSlots: { customRender: "mid" }
	},
	{
		key: "tid",
		title: "TID",
		scopedSlots: { customRender: "tid" }
	},
	{
		key: "branch_code",
		title: "Branch Code",
		scopedSlots: { customRender: "branch_code" }
	},
	{
		key: "batch_no",
		title: "Batch No",
		scopedSlots: { customRender: "batch_no" }
	},
	{
		key: "stan",
		title: "STAN",
		scopedSlots: { customRender: "stan" }
	},
	{
		key: "rrn",
		title: "RRN",
		scopedSlots: { customRender: "rrn" }
	},
	{
		key: "customer_account_number",
		title: "Customer Account Number",
		scopedSlots: { customRender: "customer_account_number" }
	},
	{
		key: "pan",
		title: "Unmasking Pan",
		scopedSlots: { customRender: "pan" }
	},
	{
		key: "product",
		title: "Product Name",
		scopedSlots: { customRender: "product" }
	},
	{
		key: "source_account_number",
		title: "Source Acc Number",
		scopedSlots: { customRender: "source_account_number" }
	},
	{
		key: "source_account_name",
		title: "Source Acc Name",
		scopedSlots: { customRender: "source_account_name" }
	},
	{
		key: "destination_account_number",
		title: "Destination Acc Number",
		scopedSlots: { customRender: "destination_account_number" }
	},
	{
		key: "destination_account_name",
		title: "Destination Acc Name",
		scopedSlots: { customRender: "destination_account_name" }
	},
	{
		key: "amount",
		title: "Amount",
		scopedSlots: { customRender: "amount" }
	},
	{
		key: "fee_agent",
		title: "Fee Agent",
		scopedSlots: { customRender: "fee_agent" }
	},
	{
		key: "fee_bank",
		title: "Fee Bank",
		scopedSlots: { customRender: "fee_bank" }
	},
	{
		key: "sn",
		title: "S/N",
		scopedSlots: { customRender: "sn" }
	},
	{
		key: "response_code",
		title: "Response Code",
		scopedSlots: { customRender: "response_code" }
	},
	{
		key: "response_message",
		title: "Response Message",
		scopedSlots: { customRender: "response_message" }
	},
	{
		key: 'response',
		title: 'Raw Response',
		scopedSlots: {customRender: 'response'}
	}
];
